export default __webpack_public_path__ + "media/images/users/user-ann-mcmillan-70x70-853cdba2513cae6d2addaae2ec05539e.jpg";